export const FILTERS = [
  {
    key: 'all',
    value: 'All'
  },
  {
    key: 'check boxes',
    value: 'Check Boxes',
  },
  {
    key: 'radio buttons',
    value: 'Radio Buttons',
  },
  {
    key: 'selectors',
    value: 'Selectors',
  },
  {
    key: 'dropdowns',
    value: 'Dropdowns',
  },
  {
    key: 'text fields',
    value: 'Text Fields',
  },
  {
    key: 'search fields',
    value: 'Search Fields',
  },
];

export const FILTERKEYS = {
  'check boxes'    : 'Check Boxes',
  'radio buttons'  : 'Radio Buttons',
  'selectors'      : 'Selectors',
  'dropdowns'      : 'Dropdowns',
  'text fields'    : 'Text Fields',
  'search fields'  : 'Search Fields'
};


// WEBPACK FOOTER //
// ./src/containers/elements/Inputs/constants/index.js